module.exports = __webpack_public_path__ + "static/scale-model-of-laredo-convention-&-visitors-in-laredo-texas-f350f11ec9cd6ad8341c771155079e30.png";